import { cubicOut } from "svelte/easing";
import type { TransitionConfig } from "svelte/transition";

interface ScaleFadeParams {
  duration?: number;
  delay?: number;
  easing?: (t: number) => number;
}

export function scalefade(
  node: Element,
  { duration = 100, delay = 0, easing = cubicOut }: ScaleFadeParams = {},
): TransitionConfig {
  return {
    duration,
    delay,
    easing,
    css: (t: number) => `
      opacity: ${t};
      transform: scale(${0.95 + 0.05 * t})
    `,
  };
}
